

















































import gql from '../gqlService.coffee'
import utils from '../utils.coffee'

export default {
    "name": 'ReviewListPaginatedForSimulation',
    "props": {
        "title": String
        "autoload": Boolean
        "height": String
        "filters": {
            "type": Object,
        }
    },
    "computed":
        style: ()->
            return {
                "height": this.height
            }
        filtered_review_set: ()->
            return {
                results: this.review_set.results,
                totalCount: this.review_set.results.length
            }
        computed_filters: ()->
            res = {
            }
            if @filters.platform? and @filters.platform.uid?
                res["platform"] = @filters.platform
            if @filters.establishment? and @filters.establishment.uid?
                res["establishment"] = @filters.establishment
            if @filters.consultant and @filters.consultant.uid?
                res["establishment__consultant__uid"] = @filters.consultant
            if @filters.search_string != ""
                res["search_vector"] = @filters.search_string
            if @filters.sentiment?
                res["positive"] = @filters.sentiment.value
            if @filters.status?
                res["current_state__class_name"] = @filters.status.value
            if @filters.classified? and @filters.classified
                res["current_state__class_name"] = "Classified"
            if @filters.dateBeginFilter? and @filters.dateBeginFilter != ""
                res["published_on__gte"] = @filters.dateBeginFilter
            if @filters.dateEndFilter? and @filters.dateEndFilter != ""
                res["published_on__lte"] = @filters.dateEndFilter
            if @filters.tag? and @filters.tag.name != null
                res["current_state__tag__iexact"] = @filters.tag.code
            if @filters.has_game_filter
                res["has_game_set"] = true
            return res
    "methods":
        "keydown": (e)->
            if e.target.tagName != "TEXTAREA"
                switch e.keyCode 
                    when 40 then e.preventDefault();
                    when 38 then e.preventDefault();
        "keyup": (e)->
            vm = this
            if e.target.tagName != "TEXTAREA"
                switch e.keyCode
                    when 40 then vm.next();
                    when 38 then vm.prev();
        "next": (e)->
            self = this;
            index = 0
            for r in self.filtered_review_set.results
                if r.uid == this.selected_review_uid
                    break
                index += 1
            if index+1 < self.filtered_review_set.results.length
                self.select(self.filtered_review_set.results[index + 1].uid)
            visible_objects = Math.floor(self.$refs['list'].offsetHeight / 82)
            to_scroll = index*82 - (visible_objects-2)*82
            if to_scroll > 0
                self.$refs['list'].scroll(0,to_scroll)
                        
        "prev": ()->
            self = this;
            index = 0
            for r in self.filtered_review_set.results
                if r.uid == this.selected_review_uid
                    break
                index += 1
            if index-1 >= 0
                self.select(self.filtered_review_set.results[index - 1].uid)
            visible_objects = Math.floor((self.$refs['list'].scrollTop) / 82)
            scrolled = self.$refs['list'].scrollTop
            to_scroll = index*82 - (visible_objects+1)*82
            if to_scroll < 0
                self.$refs['list'].scroll(0,self.$refs['list'].scrollTop+to_scroll)

        "select": (uid)->
            this.selected_review_uid = uid
            this.$emit("select_review", uid)
            # this.$router.push({
            #     "name": "team_detail",
            #     "params": {'uid': uid}
            # })
            # should_stop = false

            # for key of this.$store.state.edited_fields 
            #     f = this.$store.state.edited_fields[key]
            #     if [null, ""].indexOf(f.value) < 0
            #         should_stop = true
                
            # if not should_stop
            #     this.$store.dispatch("select_review", uid)
        "debug": ()->
            vm = @
            vm.test["plop"] = "plip"
        "query": ()->
            vm = @
            vm.loading = true
            await vm.review_set.query(vm.computed_filters)
            vm.loading = false
        "debouncedQuery": utils.debounce(
            ()->
                this.query(this.computed_filters)
            , 2000)
        "get_class": (state_name)->
            return ['state-'+state_name.toLowerCase()]
        "get_tag_name": (tag)->
            ret = null
            if tag?
                ret = this.$store.state.tag_name[tag.toLowerCase()]
            return ret
        "loadNextPage": ()->
            self = @
            this.loading = true
            this.review_set.load_next_page()
            .then ()->
                self.loading = false
            .catch ()->
                self.loading = false
        "handleScroll": (e)->
            if e.srcElement.offsetHeight+e.srcElement.scrollTop == e.srcElement.scrollHeight
                this.loadNextPage()
    "data": ()->
        vm = @
        return {
            "selected_review_uid": null,
            "test": {a:null, b:1}
            "loading": true
            "review_set": new gql.DataHolder({
                "handle_pagination": true,
                "model": "review_set_paginated",
                "fields": "uid total_count title_fr title_native text_fr text_native author positive mark published_on establishment {uid name consultant { fullname } } platform {name} current_state {verbose_name, class_name, tag} answerer {uid lastname firstname fullname} has_game_set"
                "filters": {establishment__active: true}
                "autoload": vm.autoload
            })
        }
    "mounted": ()->
        vm = @
        this.review_set.promise.then ()->
            vm.loading = false

        vm.$refs.list.addEventListener('scroll', this.handleScroll);
        
        if @$route.params.uid?
            this.$store.dispatch("select_review", @$route.params.uid)

        window.addEventListener("keydown", vm.keydown, false)
        window.addEventListener("keyup", vm.keyup, false)
    "beforeDestroy": ()->
        vm = this
        window.removeEventListener("keydown", vm.keydown)
        window.removeEventListener("keyup", vm.keyup)                        
    "updated": ()->
        vm = @
    "watch":
        "filters": (newV, oldV)->
            vm = @
            if newV.search_string != oldV.search_string
                vm.debouncedQuery(newV)
            else
                vm.query(newV)
}
